import { render, staticRenderFns } from "./SetPatientNote.vue?vue&type=template&id=33f30538"
import script from "./SetPatientNote.vue?vue&type=script&lang=js"
export * from "./SetPatientNote.vue?vue&type=script&lang=js"
import style0 from "./SetPatientNote.vue?vue&type=style&index=0&id=33f30538&prod&lang=css"
import style1 from "./SetPatientNote.vue?vue&type=style&index=1&id=33f30538&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports